export function getToken() {
    return localStorage.getItem('token')
}

export function setToken(data) {
    return localStorage.setItem('token', data)
}

export function removeToken() {
    return localStorage.removeItem('token')
}

// 判断字母是否为元音
export const isVowel = (letter, index = 0) => {
	const vowels = ['a', 'e', 'i', 'o', 'u'];
	letter = letter.toLowerCase();
	return vowels.includes(letter) || (letter === 'y' && index > 0);
};